import { render } from "./ModalResetTable.vue?vue&type=template&id=8c6f3d08"
import script from "./ModalResetTable.vue?vue&type=script&lang=js"
export * from "./ModalResetTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__